// extracted by mini-css-extract-plugin
module.exports = {"root":"LSPoolsForm_root__XqBrI","container":"LSPoolsForm_container__hcfZ2","form_wrapper":"LSPoolsForm_form_wrapper__krI0R"};